<template>
  <div class="relative w-full">
    <div class="search-full-container w-full h-full absolute left-0 top-0 px-4 mt-5" v-show="showFullSearch">
      <vx-auto-suggest
        ref="navbarSearch"
        :autoFocus="showFullSearch"
        :data="searchItems"
        :searchLimit="10"
        search_key="title"
        background-overlay
        class="w-full"
        inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
        icon="SearchIcon"
        placeholder="Find venue..."
        @input="hnd_search_query_update"
        @selected="selected"
        @closeSearchbar="showFullSearch = false"
      >
        <template v-slot:group="{ group_name }">
          <p class="font-semibold text-primary">{{ group_name | title }}</p>
        </template>

        <!-- Pages Suggestion -->
        <template v-slot:denmark="{ suggestion }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <img :src="suggestion.logo" :alt="suggestion.title" class="w-8 h-8 mr-3 rounded-full" />
              <div class="leading-none mt-1">
                <p>{{ suggestion.title }}</p>
                <small>{{ suggestion.city }}</small>
              </div>
            </div>
            <small>Select to switch</small>
          </div>
        </template>

        <template v-slot:norway="{ suggestion }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <img :src="suggestion.logo" :alt="suggestion.title" class="w-8 h-8 mr-3 rounded-full" />
              <div class="leading-none mt-1">
                <p>{{ suggestion.title }}</p>
                <small>{{ suggestion.city }}</small>
              </div>
            </div>
            <small>Select to switch</small>
          </div>
        </template>

        <template v-slot:finland="{ suggestion }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <img :src="suggestion.logo" :alt="suggestion.title" class="w-8 h-8 mr-3 rounded-full" />
              <div class="leading-none mt-1">
                <p>{{ suggestion.title }}</p>
                <small>{{ suggestion.city }}</small>
              </div>
            </div>
            <small>Select to switch</small>
          </div>
        </template>

        <template v-slot:england="{ suggestion }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <img :src="suggestion.logo" :alt="suggestion.title" class="w-8 h-8 mr-3 rounded-full" />
              <div class="leading-none mt-1">
                <p>{{ suggestion.title }}</p>
                <small>{{ suggestion.city }}</small>
              </div>
            </div>
            <small>Select to switch</small>
          </div>
        </template>

        <!-- No Items Slot -->
        <template>
          <div class="flex items-center">
            <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
            <span>No results found.</span>
          </div>
        </template>
      </vx-auto-suggest>

      <div class="absolute right-0 top-0 mt-6 pt-1 mr-4 h-full z-50">
        <feather-icon
          icon="XIcon"
          class="px-4 cursor-pointer h-full close-search-icon"
          @click="showFullSearch = false"
        />
      </div>
    </div>
    <!--<feather-icon
      icon="SearchIcon"
      @click="showFullSearch = true"
      class="cursor-pointer navbar-fuzzy-search mr-4"
    />-->
  </div>
</template>

<script>
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    VxAutoSuggest,
  },
  data() {
    return {
      navbarSearchAndPinList: this.$store.state.themeProps.navbarSearchAndPinList,
      //showFullSearch: this.$store.state.themeProps.showFullSearch,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters({
      venues: "venues/venues",
    }),
    showFullSearch: {
      get() {
        return this.$store.state.themeProps.showFullSearch;
      },
      set(value) {
        this.$store.commit("setShowFullSearch", value);
      },
    },
    searchItems() {
      return {
        denmark: {
          key: "title",
          data: this.venues
            .filter(e => e.tags.includes("country:dk"))
            .map(v => {
              return {
                title: v.name,
                url: `${v.venueId}`,
                city: v.city ? v.city : "No city",
                logo: v.logoUrl ? v.logoUrl : require(`@/assets/images/venue-image.png`),
                icon: "FileIcon",
                is_bookmarked: true,
              };
            }),
        },
        norway: {
          key: "title",
          data: this.venues
            .filter(e => e.tags.includes("country:no"))
            .map(v => {
              return {
                title: v.name,
                url: `${v.venueId}`,
                city:  v.city ? v.city : "No city",
                logo: v.logoUrl ? v.logoUrl : require(`@/assets/images/venue-image.png`),
                icon: "FileIcon",
                is_bookmarked: true,
              };
            }),
        },
        finland: {
          key: "title",
          data: this.venues
            .filter(e => e.tags.includes("country:fi"))
            .map(v => {
              return {
                title: v.name,
                url: `${v.venueId}`,
                city:  v.city ? v.city : "No city",
                logo: v.logoUrl ? v.logoUrl : require(`@/assets/images/venue-image.png`),
                icon: "FileIcon",
                is_bookmarked: true,
              };
            }),
        },
        england: {
          key: "title",
          data: this.venues
            .filter(e => e.tags.includes("country:uk"))
            .map(v => {
              return {
                title: v.name,
                url: `${v.venueId}`,
                city:  v.city ? v.city : "No city",
                logo: v.logoUrl ? v.logoUrl : require(`@/assets/images/venue-image.png`),
                icon: "FileIcon",
                is_bookmarked: true,
              };
            }),
        },
      };
    },
  },
  methods: {
    async selected(item) {
      /*item.pages ? this.$router.push(item.pages.url).catch(() => {}) : null;*/
      this.showFullSearch = false;
      const venueId = item[Object.keys(item)[0]].url;
      const venueName = item[Object.keys(item)[0]].title;
      this.switchVenue(venueId);
      this.$vs.notify({ title: venueName, text: "Venue switched to " + venueName });
    },
    hnd_search_query_update(query) {
      // Show overlay if any character is entered
      //this.$store.commit("TOGGLE_CONTENT_OVERLAY", query ? true : false);
    },
  },
};
</script>
